document.addEventListener('DOMContentLoaded', () => {
  $('.image-upload').each(function () {
    const $root = $(this)
    const $fileInput = $root.find('.image-upload__field')

    $fileInput.on('change', event => {
      const reader = new FileReader()

      reader.onload = function (e) {
        $root.find('.image-upload__image').css('background-image', `url(${e.target.result})`)
        $root.addClass('image-upload--has-image')
      }

      reader.readAsDataURL(event.currentTarget.files[0])
    })
  })
})
